import { BOOKEND_TYPES } from '@vp/esi-bookends';

export const getBookendsType = type =>
  type === 'slim' ? BOOKEND_TYPES.SLIM : BOOKEND_TYPES.FULL;

// TODO - invalidateMiniCartData() is currently broken in staging due to a bug in Bookends.
// See discussion: https://vistaprint.slack.com/archives/CHWCBMDU2/p1677256275443279
export const invalidateMiniCartData = () => {
  if (!(typeof window === `undefined` || typeof document === `undefined`)) {
    document.invalidateMiniCartData({});
  }
};
